export enum CardPackId {
    BeginnerPack = 'Beginner Pack',
    BronzeTierPack = 'Bronze Tier Pack',
    SilverTierPack = 'Silver Tier Pack',
    GoldTierPack = 'Gold Tier Pack',
    FarmPack = 'Farm Pack',
    ActionCardPack = 'Action Card Pack',
    MonsterPack = 'Monster Pack',
    Legendary = "Legendary Pack",
    CursePack = "Curse Pack",
}